// extracted by mini-css-extract-plugin
module.exports = {"securityPageWrapper":"Security_securityPageWrapper__1jCjQ","securityPage":"Security_securityPage__3FZAQ","topImage":"Security_topImage__1AZhC"};